/* Footer group scripts, loaded deferred from layout/theme.liquid <head>.
   Moved from the inline <script> blocks of the footer group snippets; every block checks for its own markup. */

/* ==== Chat launcher (markup and data: snippets/chat-launcher.liquid) ==== */
(function () {
  var root = document.querySelector('[data-cw-chat]');
  if (!root) return;
  var key = root.getAttribute('data-tidio-key') || '';
  if (!key) return;

  var teaser = root.querySelector('.cw-teaser');
  var fallback = root.querySelector('.cw-chat__fallback');
  var launcher = root.querySelector('.cw-chat__btn');
  var badge = root.querySelector('.cw-chat__badge');
  var FALLBACK_MS = 8000;

  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k) { try { window.sessionStorage.setItem(k, '1'); } catch (e) {} }

  /* Microsoft Clarity custom events (same guarded call as assets/header.js); never throws */
  function track(name) {
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  var injected = false, ready = false, wantOpen = false, fallbackTimer = null;
  var chatOpen = false, drawerOpen = false, nightOpen = false;

  function syncOverlay() { root.classList.toggle('is-hidden-for-overlay', chatOpen || drawerOpen || nightOpen); }

  /* ---------- New-chat alert: one Klaviyo client event per new Tidio conversation ----------
     Klaviyo flow "Slack Alert - Live Chat Started" turns it into a post in Slack #003.
     Key, metric and status texts come from data-notify-* (snippets/chat-launcher.liquid); without
     key or metric nothing is wired. The visitor's first text message opens the alert; one alert per
     conversation. A new one opens after ALERT_GAP_MS since the last (localStorage cw_chat_alert_at) or
     after Tidio's conversationStart, which doesn't always fire (e.g. with the pre-chat survey). The alert
     is sent at once if an email is known, else after NOTIFY_WAIT_MS (a pre-chat email arriving meanwhile
     sends it straight away), or on pagehide. Fails silently.
     A chat started from an ask button (see Chat openers) also carries chat_started_from and
     chat_question, so staff read the visitor's reply in context, and so does one started from a teaser
     answer, "Ask something else" or the unread badge (question = the teaser title); one started from the
     launcher button or café chat line carries chat_started_from only; other chats send the same payload as before. */
  var nKey = root.getAttribute('data-notify-key') || '';
  var nMetric = root.getAttribute('data-notify-metric') || '';
  var NOTIFY_WAIT_MS = 45000;
  var ALERT_GAP_MS = 12 * 60 * 60 * 1000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var pending = null, notifyTimer = null, chatEmail = '', chatPhone = '', anon = '';
  var newConvo = false, pageAlertAt = 0; // pageAlertAt: fallback when storage fails (one alert per page view)

  function cleanMsg(s) {
    s = String(s || '').replace(/\s+/g, ' ').replace(/"/g, "'").replace(/\\/g, '').trim();
    return s.length > 280 ? s.slice(0, 279) + '…' : s;
  }

  /* Random id kept in localStorage; if storage fails, one random id for this page */
  function anonId() {
    if (anon) return anon;
    try { anon = window.localStorage.getItem('cw_chat_anon') || ''; } catch (e) {}
    if (!anon) {
      anon = 'cw-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      try { window.localStorage.setItem('cw_chat_anon', anon); } catch (e) {}
    }
    return anon;
  }

  function sendAlert(keepalive) {
    if (!pending || pending.sent || !pending.msg || !window.fetch) return;
    pending.sent = true;
    clearTimeout(notifyTimer);
    var attrs = {};
    if (chatEmail) attrs.email = chatEmail;
    else if (chatPhone) attrs.phone_number = chatPhone;
    else attrs.anonymous_id = anonId();
    var api = window.tidioChatApi, online = root.classList.contains('is-online');
    try { if (!online && api && typeof api.getStatus === 'function') online = api.getStatus() === 'online'; } catch (e) {}
    var props = {
      first_message: pending.msg,
      page_title: String(document.title || '').slice(0, 120),
      page_url: location.origin + location.pathname,
      chat_status: root.getAttribute(online ? 'data-notify-on' : 'data-notify-off') || '',
      source: 'Tidio'
    };
    var ctx = getCtx();
    if (ctx) {
      props.chat_started_from = cleanMsg(ctx.from);
      var ctxQ = cleanMsg(ctx.question);
      if (ctxQ) props.chat_question = ctxQ;
      clearCtx();
    }
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(nKey), {
        method: 'POST',
        keepalive: !!keepalive,
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: nMetric } } },
          profile: { data: { type: 'profile', attributes: attrs } } } } })
      }).catch(function () {});
    } catch (e) {}
  }

  function setFirstMsg(msg) {
    pending.msg = msg;
    if (chatEmail) sendAlert(false);
    else notifyTimer = setTimeout(function () { sendAlert(false); }, NOTIFY_WAIT_MS);
  }

  /* Time of the last alert opened: the later of localStorage and this page's own record */
  function lastAlertAt() {
    var t = 0;
    try { t = parseInt(window.localStorage.getItem('cw_chat_alert_at'), 10) || 0; } catch (e) {}
    return Math.max(t, pageAlertAt);
  }

  function markAlertAt() {
    pageAlertAt = Date.now();
    try { window.localStorage.setItem('cw_chat_alert_at', String(pageAlertAt)); } catch (e) {}
  }

  function onConversationStart() {
    if (pending && pending.msg && !pending.sent) sendAlert(false); // don't drop an earlier unsent alert
    clearTimeout(notifyTimer);
    newConvo = true;
    pending = null;
  }

  function onVisitorMessage(d) {
    if (!d || d.fromBot || d.type !== 'text') return;
    var msg = cleanMsg(d.message);
    if (!msg) return;
    if (pending && !pending.msg && !pending.sent) { setFirstMsg(msg); return; }
    if (pending && !pending.sent) return; // follow-up while the open alert waits to send
    var at = lastAlertAt();
    if (!newConvo && at && Date.now() - at < ALERT_GAP_MS) return; // follow-up in the same conversation
    pending = { msg: null, sent: false };
    markAlertAt();
    newConvo = false;
    setFirstMsg(msg);
  }

  /* form_data: an object, or an array of { name/type, value } */
  function onPreForm(d) {
    var fd = d && d.form_data, vals = [];
    if (Array.isArray(fd)) {
      fd.forEach(function (f) { if (f && f.value != null) vals.push(String(f.value).trim()); });
    } else if (fd && typeof fd === 'object') {
      Object.keys(fd).forEach(function (k) { if (fd[k] != null && typeof fd[k] !== 'object') vals.push(String(fd[k]).trim()); });
    }
    vals.forEach(function (v) {
      if (!chatEmail && EMAIL_RE.test(v)) chatEmail = v;
      if (!chatPhone && v.charAt(0) === '+') {
        var digits = v.replace(/\D/g, '');
        if (digits.length >= 8 && digits.length <= 15) chatPhone = '+' + digits;
      }
    });
    if (pending && pending.msg && !pending.sent) sendAlert(false);
  }

  function initAlert(api) {
    if (!nKey || !nMetric) return;
    api.on('conversationStart', onConversationStart);
    api.on('messageFromVisitor', onVisitorMessage);
    api.on('preFormFilled', onPreForm);
    window.addEventListener('pagehide', function () { sendAlert(true); });
  }

  /* ---------- Holding messages: keep a waiting visitor in the chat until staff reply ----------
     Visitors who get no reply leave, so after the visitor's first unanswered text message we show
     holding messages in their chat window: two while staff are online (tidioChatApi.getStatus()),
     one while offline. Texts and delays come from data-hold-* (snippets/chat-launcher.liquid, from
     metaobjects.chat_launcher.main; hours from site_header.main.hours_label); without them nothing
     is wired. They are sent with tidioChatApi.messageFromOperator(), which exists in the visitor's
     browser only: staff never see them in the Tidio panel and they aren't stored. A real staff reply
     stops them for the rest of the visit (sessionStorage cw_chat_staff_replied). Each hold shows at
     most once per page view. Our own operator messages (holds and opener questions) go through
     sendOwn(), so they never count as a staff reply. Fails silently. */
  var holds = [], holdTimers = [], holdSent = {}, holdScheduled = false;
  var waitingSince = 0, staffReplied = false, ownSending = false, ownTexts = [];

  function holdDef(k) {
    var text = root.getAttribute('data-hold-' + k) || '';
    var s = parseFloat(root.getAttribute('data-hold-' + k + '-s'));
    return text && isFinite(s) && s >= 0 ? { key: k, text: text, ms: s * 1000 } : null;
  }

  function normMsg(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  function clearHolds() {
    holdTimers.forEach(function (t) { clearTimeout(t); });
    holdTimers = [];
  }

  function hasStaffReplied() { return staffReplied || ssGet('cw_chat_staff_replied') === '1'; }

  /* Shows text as an operator message in the visitor's window only, marked as ours */
  function sendOwn(api, text) {
    ownTexts.push(normMsg(text));
    ownSending = true;
    try { api.messageFromOperator(text); } catch (e) {}
    ownSending = false;
  }

  function showHold(h) {
    var api = window.tidioChatApi;
    if (hasStaffReplied() || holdSent[h.key] || !api || typeof api.messageFromOperator !== 'function') return;
    holdSent[h.key] = true;
    sendOwn(api, h.text);
  }

  function onHoldVisitorMessage(d) {
    if (!d || d.fromBot || d.type !== 'text') return;
    if (holdScheduled || hasStaffReplied()) return;
    var online = false;
    try { online = window.tidioChatApi.getStatus() === 'online'; } catch (e) {}
    var due = holds.filter(function (h) { return online ? h.key !== 'off' : h.key === 'off'; });
    if (!due.length) return;
    holdScheduled = true;
    waitingSince = Date.now();
    due.forEach(function (h) {
      holdTimers.push(setTimeout(function () { showHold(h); }, h.ms));
    });
  }

  /* Our own messageFromOperator() fires this event too: ignore it while sending, or when it echoes our text. */
  function onHoldOperatorMessage(d) {
    if (ownSending) return;
    var own = d ? ownTexts.indexOf(normMsg(d.message)) : -1;
    if (own !== -1) { ownTexts.splice(own, 1); return; }
    if (d && d.fromBot) return;
    staffReplied = true;
    ssSet('cw_chat_staff_replied');
    clearHolds();
  }

  function initHold(api) {
    holds = ['1', '2', 'off'].map(holdDef).filter(Boolean);
    if (!holds.length) return;
    api.on('messageFromVisitor', onHoldVisitorMessage);
    api.on('messageFromOperator', onHoldOperatorMessage);
  }

  /* ---------- Chat openers: ask buttons open the chat with one question ----------
     Openers come from the chat_opener metaobjects (snippets/chat-launcher.liquid,
     <script data-cw-openers>): { "<handle>": { from, q, q0 } }. openTidio(key, { models }) fills
     {models} in the question and the "started from" label; with no models it uses q0 (blank → no
     question) and drops " – {models}" from the label. The question is sent with messageFromOperator()
     once the window is open: it skips Tidio's home screen and shows only in the visitor's window (staff
     never see it in Tidio), at most once per page view. So staff know where the chat started, the
     context { from, question } goes to the next new-chat alert (chat_started_from, chat_question;
     sessionStorage cw_chat_ctx until sent) and from goes to Tidio's contact properties
     (chat_started_from). Links to /pages/contact?chat=<handle> open the chat instead of the page.
     An opener with a blank question (launcher, teaser, cafe) opens Tidio's home screen as before and only
     records { from, question: '' }: it doesn't force a new alert and never replaces an unsent context that
     has a question (the ask button's context wins). */
  var openers = {}, openerQ = '', openersAsked = {}, chatCtx = null;
  try {
    var openersEl = root.querySelector('script[data-cw-openers]');
    if (openersEl) openers = JSON.parse(openersEl.textContent) || {};
  } catch (e) { openers = {}; }

  function hasOpener(k) {
    return !!k && Object.prototype.hasOwnProperty.call(openers, k) && !!openers[k] && typeof openers[k] === 'object';
  }

  function fillOpener(k, vars) {
    var o = openers[k];
    var models = vars && vars.models != null ? String(vars.models).trim() : '';
    var q = String(o.q || ''), from = String(o.from || '');
    if (models) {
      q = q.split('{models}').join(models);
      from = from.split('{models}').join(models);
    } else {
      if (q.indexOf('{models}') !== -1) q = String(o.q0 || '').split('{models}').join('');
      from = from.replace(/\s*[–—-]\s*\{models\}/g, '').split('{models}').join('');
    }
    return { from: from.trim(), question: q.trim() };
  }

  function getCtx() {
    if (chatCtx) return chatCtx;
    try {
      var s = window.sessionStorage.getItem('cw_chat_ctx');
      if (s) chatCtx = JSON.parse(s);
    } catch (e) {}
    return chatCtx && typeof chatCtx === 'object' ? chatCtx : null;
  }

  function clearCtx() {
    chatCtx = null;
    try { window.sessionStorage.removeItem('cw_chat_ctx'); } catch (e) {}
  }

  /* A context with a question opens a new alert with the visitor's next text message, even within ALERT_GAP_MS */
  function setCtx(c) {
    chatCtx = c;
    if (c.question) newConvo = true;
    try { window.sessionStorage.setItem('cw_chat_ctx', JSON.stringify(c)); } catch (e) {}
  }
  var ctx0 = getCtx();
  if (ctx0 && ctx0.question) newConvo = true; // set on an earlier page and not yet sent

  function tagContact() {
    var api = window.tidioChatApi, c = getCtx();
    if (!c || !c.from || !api) return;
    try { api.setContactProperties({ chat_started_from: c.from }); } catch (e) {}
  }

  function sendOpener() {
    var q = openerQ, api = window.tidioChatApi;
    openerQ = '';
    if (!q || !api || typeof api.messageFromOperator !== 'function') return;
    sendOwn(api, q);
  }

  /* Teaser answers (snippets/chat-launcher.liquid, [data-answer]): the teaser title shows as our message
     (sendOwn, visitor's window only), then the answer goes in as a real visitor message
     (messageFromVisitor, if Tidio has it), so staff see it and the new-chat alert and holding messages
     fire from it as from any typed first message. "Ask something else" and a launcher tap while the
     badge shows send the title only. Each title/answer pair at most once per page view. */
  var answerQ = null, answersAsked = {};

  function sendAnswer() {
    var a = answerQ, api = window.tidioChatApi;
    answerQ = null;
    if (!a || !api) return;
    if (a.title && typeof api.messageFromOperator === 'function') sendOwn(api, a.title);
    if (a.say && typeof api.messageFromVisitor === 'function') {
      try { api.messageFromVisitor(a.say); } catch (e) {}
    }
  }

  function sendPending() { sendOpener(); sendAnswer(); }

  /* ---------- Tidio: load on demand ---------- */
  /* api.hide() hides the whole widget and open() doesn't undo it, so always show() first. */
  function openWindow() {
    var api = window.tidioChatApi;
    if (!api) return;
    api.show();
    api.open();
  }

  function onReady() {
    if (ready) return;
    ready = true;
    var api = window.tidioChatApi;
    if (!api) return;
    api.on('open', function () { chatOpen = true; syncOverlay(); });
    api.on('close', function () { chatOpen = false; api.hide(); syncOverlay(); });
    api.on('messageFromOperator', function () { if (!chatOpen) openWindow(); });
    initAlert(api);
    initHold(api);
    api.hide();
    clearTimeout(fallbackTimer);
    root.classList.remove('is-loading');
    if (fallback) fallback.hidden = true;
    tagContact();
    if (wantOpen) { openWindow(); sendPending(); }
  }

  function loadTidio() {
    if (ready) return;
    if (!injected) {
      injected = true;
      if (window.tidioChatApi && typeof window.tidioChatApi.on === 'function') {
        window.tidioChatApi.on('ready', onReady);
      } else {
        document.addEventListener('tidioChat-ready', onReady);
      }
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://code.tidio.co/' + encodeURIComponent(key) + '.js';
      document.body.appendChild(s);
    }
    if (wantOpen) {
      root.classList.add('is-loading');
      if (!fallbackTimer) {
        fallbackTimer = setTimeout(function () {
          if (ready) return;
          root.classList.remove('is-loading');
          if (fallback) fallback.hidden = false;
        }, FALLBACK_MS);
      }
    }
  }

  /* Every chat entry point on the site calls this. No key (about, search): Tidio's home screen as before.
     key = a chat_opener handle: opens straight into the conversation with that question, or on the home
     screen with only the "started from" context when its question is blank; vars = optional { models: 'X and Y' }.
     Each call sends the Clarity event chat_open_<key> (chat_open_other without a key). */
  window.openTidio = function (key, vars) {
    track('chat_open_' + (key ? String(key) : 'other'));
    if (nightTarget()) {
      var no = hasOpener(key) ? fillOpener(key, vars) : null;
      openNight({ from: no ? no.from : launcherFrom(), question: no ? no.question : '' });
      return;
    }
    if (hasOpener(key)) {
      var o = fillOpener(key, vars), id = o.from + '\n' + o.question;
      if (!o.question) {
        var cur = getCtx();
        if (o.from && !(cur && cur.question)) {
          setCtx({ from: o.from, question: '' });
          if (ready) tagContact();
        }
      } else if (!openersAsked[id]) {
        openersAsked[id] = true;
        openerQ = o.question;
        setCtx({ from: o.from, question: o.question });
        if (ready) tagContact();
      }
    }
    openNow();
  };

  /* The coffee bar tool's hand-off (assets/bar-tool.js), same store rule as every other entry point: in staff hours
     Tidio, outside them the night chat. ctx = { from, question, firstMessage, email, summary, url }: firstMessage is
     what the visitor sends (and sees); summary (the full bar) and url are for staff only. Clarity event chat_open_bar.
     Night: openNight({ from, question: '', firstMessage, context: summary, email }); a valid email is saved by the
     night window itself (no email card); context goes to Sam and staff (Slack) only and is never shown in the chat, so no teaser bubble repeats the bar. Tidio: { from, question } goes to the next
     new-chat alert (chat_started_from, chat_question) as for teaser answers, then once Tidio is ready the email is set
     as visitor data, summary / url as contact properties bar_summary / bar_url, and firstMessage is sent as the
     visitor's message. */
  var barSend = null;
  function sendBar() {
    var b = barSend, api = window.tidioChatApi;
    barSend = null;
    if (!b || !api) return;
    if (b.email) { try { api.setVisitorData({ email: b.email }); } catch (e) {} }
    if (b.summary || b.url) { try { api.setContactProperties({ bar_summary: b.summary, bar_url: b.url }); } catch (e) {} }
    if (b.say && typeof api.messageFromVisitor === 'function') { try { api.messageFromVisitor(b.say); } catch (e) {} }
  }
  window.openChatWith = function (ctx) {
    ctx = ctx || {};
    var from = String(ctx.from || ''), question = String(ctx.question || ''), say = String(ctx.firstMessage || '');
    var summary = String(ctx.summary || ''), url = String(ctx.url || '');
    var email = EMAIL_RE.test(String(ctx.email || '')) ? String(ctx.email) : '';
    track('chat_open_bar');
    if (nightTarget()) { openNight({ from: from, question: '', firstMessage: say, context: summary, email: email }); return; }
    barSend = { email: email, say: say, summary: summary, url: url };
    if (from) { setCtx({ from: from, question: question }); if (ready) tagContact(); }
    openNow();
    var go = function () { onReady(); sendBar(); };
    if (ready && window.tidioChatApi) { go(); return; }
    if (window.tidioChatApi && typeof window.tidioChatApi.on === 'function') window.tidioChatApi.on('ready', go);
    document.addEventListener('tidioChat-ready', go);
  };

  /* Opens the window (loading Tidio first if needed); any chat open ends the teaser, badge and phone intro */
  function openNow() {
    wantOpen = true;
    ssSet('cw_chat_used');
    teaserDone();
    clearBadge();
    endIntro();
    if (ready && window.tidioChatApi) { openWindow(); sendPending(); }
    else loadTidio();
  }

  /* title = the teaser question; say = the answer's visitor message ('' → title only) */
  function openAnswer(title, say, from, evt) {
    track(evt);
    if (nightTarget()) { openNight({ from: from, question: title, firstMessage: say }); return; }
    var id = title + '\n' + say;
    if (title && !answersAsked[id]) {
      answersAsked[id] = true;
      answerQ = { title: title, say: say };
      setCtx({ from: from, question: title });
      if (ready) tagContact();
    }
    openNow();
  }

  /* Product page "Still deciding?" chips (snippets/product-ask.liquid, wired in assets/product.js): the same open
     path as a teaser answer, tracked as chat_open_pdp_question */
  window.openChatQuestion = function (title, say, from) {
    openAnswer(String(title || ''), String(say || ''), String(from || ''), 'chat_open_pdp_question');
  };

  root.querySelectorAll('[data-open-chat]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn === launcher && nightUnread) { track('chat_open_badge'); openNight({ from: launcherFrom(), question: '' }); return; }
      if (btn === launcher && unread) { openAnswer(unread.title, '', unread.from, 'chat_open_badge'); return; }
      var k = btn.dataset.chatKey;
      if (!k) { window.openTidio(); return; }
      window.openTidio(k, btn.dataset.chatModel ? { models: btn.dataset.chatModel } : undefined);
    });
  });

  /* Links to /pages/contact?chat=<opener handle> (mega menu "Ask an expert", utility "Help & contact",
     brands page) open the chat; modified clicks and unknown keys navigate as usual. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || !/(^|\/)pages\/contact\/?$/.test(u.pathname)) return;
    var k = u.searchParams.get('chat');
    if (!hasOpener(k)) return;
    e.preventDefault();
    window.openTidio(k);
  });

  /* Warm up on intent: the first hover, touch or focus on the launcher starts loading Tidio
     (or the night chat's files while it would be the target). */
  if (launcher) {
    var WARM = ['pointerenter', 'touchstart', 'focus'];
    var warm = function () {
      WARM.forEach(function (t) { launcher.removeEventListener(t, warm); });
      if (nightTarget()) loadNight();
      else if (!injected) loadTidio();
    };
    WARM.forEach(function (t) { launcher.addEventListener(t, warm, { passive: true }); });
  }

  /* ---------- Cart drawer: hide while it's open ---------- */
  var drawer = document.querySelector('.cdf-drawer');
  if (drawer && 'MutationObserver' in window) {
    var syncDrawer = function () { drawerOpen = drawer.classList.contains('is-open'); syncOverlay(); };
    new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncDrawer();
  }

  /* ---------- Teaser (product, collection, home) ----------
     One question with up to three answers (snippets/chat-launcher.liquid). Due after data-teaser-delay
     seconds or once data-teaser-scroll % of the page is scrolled, whichever first, never earlier than
     MIN_TEASER_MS after the reveal; once per visit (cw_teaser_done). Desktop: never while .atc-row is on
     screen; phones: only after .atc-row has scrolled off the top (pages without it: timing only).
     First showing: one bounce (is-nudge), Clarity teaser_shown_<page> and tag chat_teaser = entry handle. */
  var teaserClosed = false, teaserDue = false, atcVisible = false, teaserShown = false;
  /* Phones: Add to cart starts below the first screen, so wait until the buyer has scrolled past it */
  var atcPassed = false;
  var teaserPhone = window.matchMedia('(max-width: 768px)');
  var atcRow = null; // set by initTeaser while the teaser can still show
  var MIN_TEASER_MS = 5000;

  function teaserDone() {
    teaserClosed = true;
    ssSet('cw_teaser_done');
    if (teaser) teaser.hidden = true;
  }

  function teaserTitle() {
    var t = teaser && teaser.querySelector('.cw-teaser__title');
    return t ? normMsg(t.textContent) : '';
  }

  /* "Started from" for the title-only open: the teaser opener's label, filled with this product's model */
  function teaserFrom() {
    if (!hasOpener('teaser')) return '';
    var m = root.getAttribute('data-teaser-model') || '';
    return fillOpener('teaser', m ? { models: m } : undefined).from;
  }

  function onTeaserShown() {
    if (teaserShown) return;
    teaserShown = true;
    endIntro();
    track('teaser_shown_' + (teaser.getAttribute('data-teaser-page') || 'other'));
    try { if (typeof window.clarity === 'function') window.clarity('set', 'chat_teaser', teaser.getAttribute('data-teaser-key') || ''); } catch (e) {}
    if (!launcher) return;
    var stop = function () { root.classList.remove('is-nudge'); };
    launcher.addEventListener('animationend', stop, { once: true });
    setTimeout(stop, 1000); // reduced motion: no animation, no animationend
    root.classList.add('is-nudge');
  }

  function updateTeaser() {
    if (!teaser) return;
    var show = teaserPhone.matches
      ? teaserDue && !teaserClosed && atcPassed
      : teaserDue && !teaserClosed && !atcVisible;
    if (show && teaser.hidden) ssSet('cw_teaser_done'); // counts as this visit's showing
    teaser.hidden = !show;
    if (show) onTeaserShown();
  }

  /* Close button or Escape: teaser closed unread → badge (if enabled) */
  function closeTeaser() {
    teaserDone();
    track('teaser_closed');
    showBadge({ title: teaserTitle(), from: teaserFrom() }, true);
    if (launcher) launcher.focus();
  }

  function initTeaser() {
    if (!teaser) return;
    if (ssGet('cw_teaser_done') === '1') { teaserClosed = true; return; }

    teaser.querySelector('.cw-teaser__close').addEventListener('click', closeTeaser);
    teaser.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeTeaser();
    });
    teaser.querySelectorAll('[data-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openAnswer(teaserTitle(), btn.getAttribute('data-say') || '', btn.getAttribute('data-from') || '', 'chat_open_teaser_answer');
      });
    });
    var more = teaser.querySelector('[data-teaser-more]');
    if (more) more.addEventListener('click', function () {
      openAnswer(teaserTitle(), '', teaserFrom(), 'chat_open_teaser_more');
    });

    var row = document.querySelector('.atc-row');
    atcRow = row;
    if (!row) atcPassed = true; // collection and home pages: timing rule only
    if (row && 'IntersectionObserver' in window) {
      var r = row.getBoundingClientRect();
      atcVisible = r.top < window.innerHeight && r.bottom > 0;
      atcPassed = !atcVisible && r.bottom <= 0;
      new IntersectionObserver(function (entries) {
        atcVisible = entries[0].isIntersecting;
        atcPassed = !atcVisible && entries[0].boundingClientRect.bottom <= 0;
        updateTeaser();
      }).observe(row);
    }
    /* Rotating or resizing across 768px switches rule straight away */
    if (teaserPhone.addEventListener) teaserPhone.addEventListener('change', updateTeaser);
    else if (teaserPhone.addListener) teaserPhone.addListener(updateTeaser);

    var minPassed = false, scrollHit = false;
    function due() {
      if (teaserDue) return;
      teaserDue = true;
      window.removeEventListener('scroll', onScroll);
      updateTeaser();
    }
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY >= max * pct / 100) scrollHit = true;
      if (scrollHit && minPassed) due();
    }
    var delay = parseInt(root.getAttribute('data-teaser-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = 20;
    var pct = parseInt(root.getAttribute('data-teaser-scroll'), 10);
    if (isNaN(pct) || pct < 0) pct = 50;
    setTimeout(due, Math.max(delay * 1000, MIN_TEASER_MS));
    setTimeout(function () { minPassed = true; onScroll(); }, MIN_TEASER_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Unread badge ----------
     Only after the teaser was closed unread (data-badge set): shows "1", stores { title, from } in
     sessionStorage cw_chat_unread so later pages of the visit show it too; the launcher is described by
     #cwChatUnread (the teaser title) while it shows. A launcher tap then opens the chat with the title
     (Clarity chat_open_badge). Any chat open clears it. */
  var unread = null;
  var unreadDesc = root.querySelector('#cwChatUnread');

  function showBadge(u, store) {
    if (!badge || !root.hasAttribute('data-badge') || !u || !u.title) return;
    unread = { title: String(u.title), from: String(u.from || '') };
    if (store) { try { window.sessionStorage.setItem('cw_chat_unread', JSON.stringify(unread)); } catch (e) {} }
    badge.hidden = false;
    if (unreadDesc && launcher) {
      unreadDesc.textContent = unread.title;
      launcher.setAttribute('aria-describedby', unreadDesc.id);
    }
  }

  function clearBadge() {
    unread = null;
    nightUnread = false;
    try { window.sessionStorage.removeItem('cw_chat_unread'); } catch (e) {}
    if (badge) badge.hidden = true;
    if (launcher) launcher.removeAttribute('aria-describedby');
  }

  function restoreBadge() {
    var u = null;
    try { u = JSON.parse(window.sessionStorage.getItem('cw_chat_unread') || 'null'); } catch (e) { u = null; }
    if (u && typeof u === 'object') showBadge(u, false);
  }

  /* ---------- Reply by: weekday or weekend text in [data-reply-by] ----------
     data-hours = site_header support_hours { tz, days, open, close } (same format as assets/header.js).
     Saturday, Sunday or Friday at/after close in tz → data-reply-weekend; otherwise data-reply-weekday.
     Missing or invalid hours, or no weekend text → the weekday text stays. Runs at the reveal and every 5 min. */
  var replyWeekday = root.getAttribute('data-reply-weekday') || '';
  var replyWeekend = root.getAttribute('data-reply-weekend') || '';

  function hoursCfg() {
    try { return JSON.parse(root.getAttribute('data-hours') || '') || null; } catch (e) { return null; }
  }

  /* Weekday short name and HH:MM now in tz */
  function nowIn(tz) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
    return { day: get('weekday'), hm: get('hour') + ':' + get('minute') };
  }

  /* Saturday, Sunday or Friday at/after close in tz; false when hours are missing or invalid */
  function weekendReply() {
    try {
      var cfg = hoursCfg();
      if (cfg && cfg.tz && /^\d\d:\d\d$/.test(cfg.close || '')) {
        var n = nowIn(cfg.tz);
        return n.day === 'Sat' || n.day === 'Sun' || (n.day === 'Fri' && n.hm >= cfg.close);
      }
    } catch (e) {}
    return false;
  }

  function applyReplyBy() {
    if (!replyWeekday) return;
    var text = replyWeekend && weekendReply() ? replyWeekend : replyWeekday;
    root.querySelectorAll('[data-reply-by]').forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* ---------- Night chat: our own off-hours chat window instead of Tidio ----------
     Config: <script type="application/json" data-night-chat> (snippets/night-chat.liquid, only when
     night_chat.main server_url is set; without it nothing here changes anything). nightTarget(): config present
     and (test switch, or outside support hours per data-hours [same rule as assets/header.js], whatever Tidio's
     online status). Missing or invalid hours → Tidio as before. Test switch: ?nightchat=1 sets
     sessionStorage cw_night_force for the visit, ?nightchat=0 clears it.
     Every entry point (openTidio, teaser answers, "Ask something else", badge) keeps its Clarity event, then
     opens assets/night-chat.js's window with { from, question, firstMessage } instead of Tidio. The window's
     files load on the first open or on launcher warm-up (never on page view), or at the reveal when a night chat
     already exists in this visit (sessionStorage cw_night_chat) so late replies arrive. Night chats never touch
     Tidio, its context (cw_chat_ctx) or the Klaviyo new-chat alert; the server sends its own. While the window is
     open the launcher hides (is-hidden-for-overlay). Files not loading → today's phone fallback line. */
  var nightCfg = null, nightState = 0, nightQueue = [], nightUnread = false; // nightState: 0 idle, 1 loading, 2 ready, -1 failed
  try {
    var nightEl = root.querySelector('script[data-night-chat]');
    if (nightEl) nightCfg = JSON.parse(nightEl.textContent) || null;
  } catch (e) { nightCfg = null; }
  if (nightCfg && !(nightCfg.server && nightCfg.js && nightCfg.css)) nightCfg = null;

  (function () {
    var p = null;
    try { p = new URLSearchParams(location.search).get('nightchat'); } catch (e) {}
    if (p === '1') ssSet('cw_night_force');
    else if (p === '0') { try { window.sessionStorage.removeItem('cw_night_force'); } catch (e) {} }
  })();

  /* true / false per data-hours; null when hours are missing or invalid */
  function inSupportHours() {
    var cfg = hoursCfg();
    if (!(cfg && cfg.tz && Array.isArray(cfg.days) && /^\d\d:\d\d$/.test(cfg.open || '') && /^\d\d:\d\d$/.test(cfg.close || ''))) return null;
    try {
      var n = nowIn(cfg.tz);
      var day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(n.day) + 1;
      return cfg.days.indexOf(day) !== -1 && n.hm >= cfg.open && n.hm < cfg.close;
    } catch (e) { return null; }
  }

  function nightTarget() {
    if (!nightCfg) return false;
    if (ssGet('cw_night_force') === '1') return true;
    return inSupportHours() === false;
  }

  /* is-night on the launcher root while Sam is the chat target → green dot, Crawford mark and "Chat now" only,
     no expert photo or "Online now" (footer.css); also on <html> for the contact page's chat button label. is-online stays assets/header.js's.
     Re-checked every 60 s as support hours start or end. The launcher's aria-label follows: data-label-night
     ("Chat now") at night, its own label otherwise. */
  var dayLabel = launcher && launcher.getAttribute('aria-label');
  var nightLabel = launcher && launcher.getAttribute('data-label-night');
  function syncNightClass() {
    var on = nightTarget();
    root.classList.toggle('is-night', on);
    document.documentElement.classList.toggle('is-night', on);
    if (launcher && nightLabel && dayLabel) launcher.setAttribute('aria-label', on ? nightLabel : dayLabel);
  }
  syncNightClass();
  setInterval(syncNightClass, 60 * 1000);

  function hasNightChat() {
    try { var s = JSON.parse(window.sessionStorage.getItem('cw_night_chat') || 'null'); return !!(s && s.id); } catch (e) { return false; }
  }

  /* "Started from" for the launcher and calls without an opener: the launcher opener's label */
  function launcherFrom() { return hasOpener('launcher') ? fillOpener('launcher').from : ''; }

  function showNightBadge(text) {
    if (!badge || nightOpen) return;
    nightUnread = true;
    badge.hidden = false;
    if (unreadDesc && launcher && text) {
      unreadDesc.textContent = String(text).slice(0, 200);
      launcher.setAttribute('aria-describedby', unreadDesc.id);
    }
  }

  function initNight() {
    window.cwNightChat.init({
      cfg: nightCfg,
      track: track,
      weekend: weekendReply,
      hours: hoursCfg(),
      replyWeekday: replyWeekday,
      replyWeekend: replyWeekend,
      onOpen: function () { nightOpen = true; clearBadge(); syncOverlay(); track('night_open'); },
      onClose: function () { nightOpen = false; syncOverlay(); if (launcher) launcher.focus(); },
      onUnread: showNightBadge
    });
  }

  /* Loads night-chat.css + .js once; cb(ok) */
  function loadNight(cb) {
    if (cb) nightQueue.push(cb);
    if (nightState === 1) return;
    if (nightState !== 0) { flushNight(); return; }
    nightState = 1;
    var left = 2;
    var timer = setTimeout(function () { finishNight(false); }, FALLBACK_MS);
    function finishNight(ok) {
      if (nightState !== 1) return;
      clearTimeout(timer);
      if (ok) { try { initNight(); } catch (e) { ok = false; } }
      nightState = ok ? 2 : -1;
      flushNight();
    }
    function part() { if (--left === 0) finishNight(!!(window.cwNightChat && typeof window.cwNightChat.open === 'function')); }
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = nightCfg.css;
    l.onload = part;
    l.onerror = function () { finishNight(false); };
    document.head.appendChild(l);
    var s = document.createElement('script');
    s.async = true;
    s.src = nightCfg.js;
    s.onload = part;
    s.onerror = function () { finishNight(false); };
    document.body.appendChild(s);
  }

  function flushNight() {
    var q = nightQueue, ok = nightState === 2;
    nightQueue = [];
    q.forEach(function (f) { f(ok); });
  }

  /* Same side effects as openNow() (teaser, badge, intro), then the night window; no Tidio, no alert context */
  function openNight(ctx) {
    teaserDone();
    clearBadge();
    endIntro();
    if (nightState !== 2) root.classList.add('is-loading');
    loadNight(function (ok) {
      root.classList.remove('is-loading');
      if (ok) {
        try { window.cwNightChat.open(ctx); return; } catch (e) {}
      }
      if (fallback) fallback.hidden = false;
    });
  }

  /* ---------- Phone intro: label + status on the round button, first page of a visit ----------
     data-intro-seconds set, phone width, sessionStorage cw_chat_intro not set → cw-chat--intro for that many
     seconds; ends at once when the teaser shows or the chat opens. */
  var introTimer = null;

  function endIntro() {
    clearTimeout(introTimer);
    root.classList.remove('cw-chat--intro');
  }

  function initIntro() {
    var s = parseFloat(root.getAttribute('data-intro-seconds'));
    if (!isFinite(s) || s <= 0 || !teaserPhone.matches || root.classList.contains('cw-chat--no-button')) return;
    if (ssGet('cw_chat_intro') === '1') return;
    ssSet('cw_chat_intro');
    root.classList.add('cw-chat--intro');
    introTimer = setTimeout(endIntro, s * 1000);
  }

  /* Jumps (in-page links, scrollTo) can skip the row without it ever intersecting, so also check on scroll */
  function syncAtc() {
    if (!atcRow) return;
    var r = atcRow.getBoundingClientRect();
    atcVisible = r.top < window.innerHeight && r.bottom > 0;
    atcPassed = !atcVisible && r.bottom <= 0;
    updateTeaser();
  }

  /* ---------- Desktop product pages: round button while the pill would cover the buy panel ---------- */
  var buyPanel = document.querySelector('.buy-panel');
  var wide = window.matchMedia('(min-width: 769px)');
  var pillW = 0, pillH = 0, remeasure = true;

  function updateCompact() {
    if (!buyPanel || !launcher) return;
    var compact = root.classList.contains('cw-chat--compact');
    if (!wide.matches) { if (compact) root.classList.remove('cw-chat--compact'); return; }
    var b = launcher.getBoundingClientRect();
    if (!b.width) return; // hidden behind an overlay
    /* Pill size is measured in pill form only; right and bottom are the same in both forms */
    if (!compact && (remeasure || !pillW)) { pillW = b.width; pillH = b.height; remeasure = false; }
    if (!pillW) return;
    var p = buyPanel.getBoundingClientRect(), M = 8;
    var hit = b.right - pillW < p.right + M && b.right > p.left - M &&
              b.bottom - pillH < p.bottom + M && b.bottom > p.top - M;
    if (hit !== compact) root.classList.toggle('cw-chat--compact', hit);
  }

  var frame = 0;
  function onLayout() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () { frame = 0; updateCompact(); syncAtc(); });
  }

  function initLayout() {
    if (!buyPanel && !atcRow) return;
    updateCompact();
    syncAtc();
    window.addEventListener('scroll', onLayout, { passive: true });
    window.addEventListener('resize', function () { remeasure = true; onLayout(); });
  }

  /* ---------- Reveal when the DOM is ready and the main thread is idle ---------- */
  function idle(fn, timeout) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: timeout });
    else setTimeout(fn, 1000);
  }

  function reveal() {
    root.hidden = false;
    applyReplyBy();
    if (replyWeekday) setInterval(applyReplyBy, 5 * 60 * 1000);
    restoreBadge();
    initIntro();
    initTeaser();
    initLayout();
    /* Night chat in progress this visit → load its window (closed) so late replies arrive */
    if (nightCfg && hasNightChat()) idle(function () { loadNight(); }, 2000);
    /* Chat used this visit → load now so operator replies arrive; otherwise preload after preload_seconds (blank → on demand) */
    if (ssGet('cw_chat_used') === '1') { loadTidio(); return; }
    var preload = parseInt(root.getAttribute('data-preload'), 10);
    if (isNaN(preload) || preload < 0) return;
    setTimeout(function () { idle(loadTidio, 2000); }, preload * 1000);
  }

  function onDomReady() { idle(reveal, 1500); }
  if (document.readyState !== 'loading') onDomReady();
  else document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
})();

/* ==== Google Merchant store badge position (widget started in layout/theme.liquid) ====
   Google's script adds #google-merchantwidget-iframe-wrapper after load and writes its position inline
   with !important (bottom:56px; left:-5px), which no stylesheet rule can beat, so we set our own inline
   !important values. They mirror .cw-chat in footer.css: same bottom calc on --tidio-bottom (so the badge
   is level with the chat bubble and rises with it above the sticky bar / compare tray), and the same side
   margin (16px at <=768px, 20px above), on the left. If Google rewrites the style we re-apply, but only
   when bottom/left differ from ours, so our own writes don't loop. Gives up quietly after ~20 s. */
(function () {
  var ID = 'google-merchantwidget-iframe-wrapper';
  // Google draws the badge circle ~16px inside its iframe (shadow room) on the bottom and side;
  // subtract it so the visible circle lines up with the chat bubble.
  var INSET = 16;
  var BOTTOM = 'calc(var(--tidio-bottom, 10px) + 10px - ' + INSET + 'px + env(safe-area-inset-bottom, 0px))';
  var phone = window.matchMedia('(max-width: 768px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wrap = null, want = null;

  function leftValue() { return 'calc(max(' + (phone.matches ? '16px' : '20px') + ', env(safe-area-inset-left, 0px)) - ' + INSET + 'px)'; }

  function apply() {
    var s = wrap.style;
    s.setProperty('bottom', BOTTOM, 'important');
    s.setProperty('left', leftValue(), 'important');
    if (!reduce.matches) s.setProperty('transition', 'bottom .28s ease', 'important');
    // Keep the browser's serialized form so the comparison below matches exactly.
    want = { bottom: s.getPropertyValue('bottom'), left: s.getPropertyValue('left') };
  }

  function differs(p) { return wrap.style.getPropertyValue(p) !== want[p] || wrap.style.getPropertyPriority(p) !== 'important'; }

  function attach(el) {
    wrap = el;
    apply();
    new MutationObserver(function () {
      if (differs('bottom') || differs('left')) apply();
    }).observe(el, { attributes: true, attributeFilter: ['style'] });
    if (phone.addEventListener) phone.addEventListener('change', apply);
  }

  var found = document.getElementById(ID);
  if (found) { attach(found); return; }

  var watcher = new MutationObserver(function () {
    var el = document.getElementById(ID);
    if (!el) return;
    watcher.disconnect();
    attach(el);
  });
  watcher.observe(document.body, { childList: true, subtree: true });

  // The widget loads after window load + idle, so count the ~20 s from load.
  function giveUp() { setTimeout(function () { watcher.disconnect(); }, 20000); }
  if (document.readyState === 'complete') giveUp(); else window.addEventListener('load', giveUp, { once: true });
})();

/* ==== Newsletter band (markup and data: snippets/footer-newsletter-bar.liquid) ==== */

/* Scroll the band into view after a post or on errors (the snippet outputs data-jump then) */
(function () {
  var band = document.querySelector('#ftr-news[data-jump]');
  if (!band) return;
  function jump() { band.scrollIntoView({ block: 'center' }); }
  if (document.readyState === 'complete') jump(); else window.addEventListener('load', jump);
})();

/* Submit button "sending" state */
(function () {
  var form = document.getElementById('vip_newsletter_form');
  var btn = form && form.querySelector('.ftr-news__btn');
  if (!btn) return;
  var original = btn.textContent;
  form.addEventListener('submit', function () {
    if (!form.checkValidity()) return;
    // Disable after the submit has started so the button stays part of the submission
    setTimeout(function () {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-sending');
      btn.textContent = btn.dataset.sendingLabel || original;
    }, 0);
  });
  // Back/forward cache restores the page as it was left; put the button back
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.classList.remove('is-sending');
    btn.textContent = original;
  });
})();

/* Copy-code chip (shown after signup) */
(function () {
  document.querySelectorAll('.ftr-code').forEach(function (btn) {
    var label = btn.querySelector('.ftr-code__action');
    var timer;
    function selectCode() {
      var range = document.createRange();
      range.selectNodeContents(btn.querySelector('.ftr-code__value'));
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    function copied() {
      clearTimeout(timer);
      btn.classList.add('is-copied');
      label.textContent = btn.dataset.copiedLabel || '';
      timer = setTimeout(function () {
        btn.classList.remove('is-copied');
        label.textContent = btn.dataset.copyLabel || '';
      }, 2000);
    }
    btn.addEventListener('click', function () {
      try {
        navigator.clipboard.writeText(btn.dataset.code).then(copied, selectCode);
      } catch (e) {
        selectCode();
      }
    });
  });
})();

/* ==== Smooth anchor scrolling with header offset (global; moved from snippets/global-js.liquid) ==== */
(function smoothAnchors(){
  const HEADER_OFFSET_DESK = 10;   // adjust for your sticky header
  const HEADER_OFFSET_MOB  = 10;

  function offsetTop(el){
    const y = el.getBoundingClientRect().top + window.pageYOffset;
    return y - (window.innerWidth <= 800 ? HEADER_OFFSET_MOB : HEADER_OFFSET_DESK);
  }

  function smoothScrollToId(id, pushHash = true){
    const el = document.getElementById(id);
    if (!el) return;
    window.scrollTo({ top: offsetTop(el), behavior: 'smooth' });
    if (pushHash) history.pushState(null, '', '#' + id);
    el.classList.add('highlight-flash');
    setTimeout(()=> el.classList.remove('highlight-flash'), 1500);
  }

  // --- One-time guard: strip stale data-target-tab when pane doesn't exist ---
  document.addEventListener('DOMContentLoaded', function(){
    const tabsRoot = document.querySelector('.custom-tabs');
    // Example: rating link still has data-target-tab="tab-reviews" but tabs now use "-pane"
    document.querySelectorAll('a[href="#tab-reviews"][data-target-tab]').forEach(a=>{
      const targetTab = a.getAttribute('data-target-tab') || '';
      const paneExists = !!(tabsRoot && tabsRoot.querySelector('#' + CSS.escape(targetTab)));
      if (!paneExists) a.removeAttribute('data-target-tab');
    });
  });

  // Intercept in-page anchors
  document.addEventListener('click', function(e){
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const href = a.getAttribute('href');
    const id = href.slice(1);
    if (!id) return;

    const tabsRoot = document.querySelector('.custom-tabs');

    // If this anchor is meant for the tab system AND that pane exists, let tabs handle it.
    if (a.hasAttribute('data-target-tab')) {
      const tabId = a.getAttribute('data-target-tab');
      const paneInsideTabs = !!(tabsRoot && tabsRoot.querySelector('#' + CSS.escape(tabId)));
      if (paneInsideTabs) return; // do not intercept → tab script takes over
      // else: fall through to smooth-scroll to the hash target instead
    }

    // Also ignore clicks that originate INSIDE .custom-tabs (their logic owns it)
    if (a.closest('.custom-tabs')) return;

    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    smoothScrollToId(id, true);
  });

  // If the page loads with a hash, re-apply smooth + offset (avoid UA instant jump)
  window.addEventListener('load', function(){
    const id = location.hash && location.hash.slice(1);
    if (!id) return;

    const tabsRoot = document.querySelector('.custom-tabs');
    // If the hash points to a pane INSIDE .custom-tabs, let the tabs code handle it
    if (tabsRoot && tabsRoot.querySelector('#' + CSS.escape(id))) return;

    const el = document.getElementById(id);
    if (!el) return;

    // Undo UA jump, then do offset smooth scroll
    window.scrollTo(0, 0);
    setTimeout(() => smoothScrollToId(id, false), 0);
  });
})();
